<template>
  <Layout class="main-container">
    <!--    搜索块-->
    <Form
      ref="SearchForm"
      class="search-form-container"
      :model="params"
      label-position="left"
      :label-width="80"
    >
      <div class="search-form-container__content">
        <Row :gutter="16">
          <Col span="6">
            <FormItem label="订单编号:" prop="OrderCode">
              <Input placeholder="请输入订单编号" v-model="params.OrderCode" />
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem label="会员编号:" prop="MemberCode">
              <Input placeholder="请输入会员编号" v-model="params.MemberCode" />
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem label="物流单号:" prop="ShippingCode">
              <Input
                placeholder="请输入物流单号"
                v-model="params.ShippingCode"
              />
            </FormItem>
          </Col>
          <Col span="6">
            <FormItem label="收货人:" prop="ReceiveSearchText">
              <Input
                placeholder="请输入收货人名称/电话/地址"
                v-model="params.ReceiveSearchText"
              />
            </FormItem>
          </Col>
        </Row>
        <Row :gutter="16">
          <!-- <Col span="6">
          <FormItem label="订单状态:"
                    prop="OrderStatus">
            <Select clearable
                    v-model="params.OrderStatus"
                    placeholder="订单状态">
              <Option v-for="(item,index) in orderStatusEnum"
                      :key="index"
                      :value="item.ID">{{ item.CN }}</Option>
            </Select>
          </FormItem>
          </Col> -->
          <!-- <Col span="6">
            <FormItem label="订单类型:" prop="OrderType">
              <Select
                clearable
                v-model="params.OrderType"
                placeholder="订单类型"
              >
                <Option
                  v-for="(item, index) in orderTypeEnum"
                  :key="index"
                  :value="item.ID"
                  >{{ item.CN }}</Option
                >
              </Select>
            </FormItem>
          </Col> -->
          <Col span="6">
            <FormItem label="商品名称:" prop="ProductName">
              <Input
                placeholder="请输入商品名称"
                v-model="params.ProductName"
              />
            </FormItem>
          </Col>
          <Col span="12">
            <FormItem label="下单时间:" prop="TempDate">
              <Date-picker
                style="width: 100%"
                clearable
                v-model="params.TempDate"
                ref="date"
                type="datetimerange"
                :options="options"
                placement="bottom-end"
                placeholder="下单日期范围"
                format="yyyy-MM-dd HH:mm:ss"
                @on-change="dateUpdate"
              ></Date-picker>
            </FormItem>
          </Col>
        </Row>
      </div>
      <Row type="flex" justify="space-between" align="bottom" class="mt5">
        <Col span="12" style="text-align: left">
          <Button
            type="success"
            @click="batchPrintSheet"
            :loading="loading"
            v-if="$canAction(['Order_SendEms'])"
          >
            打印面单
          </Button>
          <Button
            class="ml2"
            type="success"
            @click="isShowBulkShipmentModal = true"
            :loading="loading"
            v-if="$canAction(['Order_SendEms'])"
          >
            一页多单
          </Button>
          <Button
            class="ml2"
            type="error"
            @click="onBatchCancelDelivery"
            :loading="loading"
            v-if="$canAction(['Order_SendEms'])"
          >
            批量取消发货
          </Button>
        </Col>
        <Col span="12" style="text-align: right">
          <span
            class="search-form-container__arrow_btn"
            @click="$handleHiddenSearch($el)"
          >
            收起
            <Icon type="ios-arrow-up" />
          </span>
          <Button
            class="ml2 search-form-container__button"
            type="primary"
            ghost
            icon="ios-search"
            @click="handleSearch"
          >
            搜索
          </Button>
          <Button
            class="ml2 search-form-container__button"
            @click="handleReset"
          >
            重置
          </Button>
        </Col>
      </Row>
    </Form>
    <!--    table-->
    <Table
      class="mt10 main-table"
      :loading="tableLoading"
      :height="tableHeight"
      :row-class-name="RowClassName"
      ref="dataTable"
      :columns="columns"
      :data="resObj.DataList"
      highlight-row
      @on-sort-change="onSortChange"
      size="small"
      stripe
      @on-select-all-cancel="handleSelectAllCancel"
      @on-select-cancel="handleSelectCancel"
      @on-select="handleSelect"
      @on-select-all="handleSelect"
    >
      <template slot="ShippingCode" slot-scope="{ row }">
        <span v-if="row.ShippingCode">{{ row.ShippingCode }}</span>
        <span v-else>未发货</span>
      </template>
      <template slot="MemberView" slot-scope="{ row }">
        <span
          style="color: green; cursor: pointer"
          @click="handleOpenUser(row.MemberCode)"
        >
          {{ row.MemberCode }}
        </span>
      </template>
      <template slot="OrderStatus" slot-scope="{ row }">
        <Tag
          type="border"
          :color="
            row.OrderStatus === 10
              ? 'green'
              : row.OrderStatus === 20
              ? 'volcano'
              : row.OrderStatus === 30
              ? 'magenta'
              : row.OrderStatus === 40
              ? 'red'
              : row.OrderStatus === 50
              ? 'orange'
              : 'default'
          "
        >
          {{ row.StatusCN }}
        </Tag>
      </template>
      <template slot="Action" slot-scope="{ row }">
        <Button
          size="small"
          type="primary"
          v-if="$canAction(['ShippedOrder_Search'])"
          @click="openDrawer(row, false)"
        >
          查看
        </Button>
      </template>
      <template slot="FreightTypeCN" slot-scope="{ row }">
        <Tag
          type="border"
          :color="
            row.FreightType === 10
              ? 'red'
              : row.FreightType === 20
              ? 'purple'
              : 'blue'
          "
        >
          {{ row.FreightTypeCN }}
        </Tag>
      </template>
    </Table>
    <!--    分页-->
    <Row class="mt10">
      <Col span="24" class="flex-end">
        <Page
          :page-size-opts="[40, 60, 80, 100]"
          :page-size="40"
          :total="resObj.TotalCount"
          :current="resObj.CurrentPage"
          @on-change="handleChangePage"
          size="small"
          show-elevator
          show-total
        />
      </Col>
    </Row>
    <detail-drawer ref="DetailDrawer" />
    <user-profile-drawer ref="userDrawer" />
    <!--    批量发货-->
    <Modal
      title="批量发货"
      class-name="i-modal"
      v-model="isShowBulkShipmentModal"
      loading
    >
      <Form :model="bulkShipmentForm" :label-width="120">
        <FormItem prop="ExpressCode" label="物流公司:">
          <Select
            @on-change="handleChangeExpressCode"
            v-model="bulkShipmentForm.ExpressCode"
            label-in-value
            placeholder="请选择物流公司"
          >
            <Option
              v-for="item in expressList"
              :key="item.Code"
              :value="item.Code"
            >
              {{ item.Name }}
            </Option>
          </Select>
        </FormItem>
        <FormItem prop="ShippingDate" label="发货时间:">
          <DatePicker
            placeholder="请选择发货时间"
            type="datetime"
            v-model="bulkShipmentForm.ShippingDate"
            format="yyyy-MM-dd HH:mm:ss"
            style="width: 100%"
          ></DatePicker>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="default" @click="isShowBulkShipmentModal = false">
          取消
        </Button>
        <Button type="primary" @click="handleBulkShipment"> 确定 </Button>
      </div>
    </Modal>
    <div id="printHtml" style="display: none">
      <form
        id="printForm"
        action="https://www.kdniao.com/External/PrintOrder.aspx"
        method="post"
        target="_blank"
      >
        <input type="text" id="EBusinessID" name="EBusinessID" />
        <input type="text" value="0" id="IsPreview" name="IsPreview" />
        <input type="text" id="RequestData" name="RequestData" />
        <input type="text" id="DataSign" name="DataSign" />
      </form>
    </div>
  </Layout>
</template>

<script>
import api from "@/api";
import Layout from "@/components/layout/index.vue";
import bizEnum from "@/libs/bizEnum";
import DetailDrawer from "./components/detail-drawer.vue";
import UserProfileDrawer from "../member/components/member-drawer.vue";
import moment from "moment/moment";
export default {
  name: "ShippedOrder",
  data() {
    return {
      isShowBulkShipmentModal: false,
      bulkShipmentForm: {
        print: false,
        ExpressCode: "",
        ExpressName: "",
        ShippingDate: "",
        isMerge: true,
      },
      tableHeight: 0,
      loading: false,
      tableLoading: false,
      isSearchMore: false,
      params: {
        OrderCode: "",
        MemberCode: "",
        ReceiveSearchText: "",
        ReceiveName: "",
        ReceivePhone: "",
        ShippingCode: "",
        OrderDateBegin: "",
        OrderDateEnd: "",
        ProductName: "",
        OrderStatus: 40,
        OrderType: "",
        Page: 1,
        PageSize: 40,
        SortName: "OrderDate",
        SortOrder: "Desc",
      },
      columns: [
        { type: "selection", width: 43, align: "center", minWidth: 50 },
        {
          title: "订单编号",
          key: "OrderCode",
          minWidth: 175,
          sortable: "custom",
        },
        // {
        //   title: "会员编号",
        //   key: "MemberCode",
        //   slot: "MemberView",
        //   align: "center",
        //   minWidth: 90,
        //   sortable: "custom",
        // },
        {
          title: "总金额",
          key: "TotalAmount",
          minWidth: 80,
          sortable: "custom",
        },
        {
          title: "商品名",
          key: "ProductName",
          minWidth: 130,
          sortable: "custom",
        },
        {
          title: "商品数量",
          key: "ProductCount",
          minWidth: 90,
          sortable: "custom",
        },
        { title: "收货姓名", key: "ReceiveName", minWidth: 95 },
        { title: "收货人电话", key: "ReceivePhone", minWidth: 95 },
        { title: "收货地址", key: "ReceiveAddress", minWidth: 220 },
        {
          title: "物流单号",
          key: "ShippingCode",
          slot: "ShippingCode",
          minWidth: 140,
          sortable: "custom",
          ellipsis: true,
        },
        {
          title: "物流公司",
          key: "ExpressName",
          align: "center",
          minWidth: 80,
        },
        // {
        //   title: "运费方式",
        //   key: "FreightTypeCN",
        //   align: "center",
        //   slot: "FreightTypeCN",
        //   minWidth: 95,
        //   sortable: "custom",
        // },
        {
          title: "下单时间",
          key: "OrderDate",
          align: "center",
          minWidth: 135,
          sortable: "custom",
        },
      ],
      selections: [],
      resObj: {
        CurrentPage: 1,
        TotalCount: 0,
        TotalPage: 0,
        DataList: [],
      },
      expressList: [],
      options: {
        shortcuts: [
          {
            text: "最近一周",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              return [start, end];
            },
          },
          {
            text: "最近一个月",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              return [start, end];
            },
          },
          {
            text: "最近三个月",
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              return [start, end];
            },
          },
        ],
      },
    };
  },
  created() {
    if (this.$route.meta.tableActionWidth) {
      this.columns.push({
        title: "操作",
        key: "action",
        slot: "Action",
        fixed: "right",
        width: this.$route.meta.tableActionWidth,
        align: "right",
      });
    }
    this.loadOrderList();
  },
  watch: {
    isShowBulkShipmentModal(val) {
      if (val) {
        this.bulkShipmentForm.ShippingDate = moment().format();
        this.GetExpressList();
      } else {
        this.bulkShipmentForm = {
          ids: [],
          ExpressCode: "",
          ExpressName: "",
          ShippingDate: "",
          isMerge: true,
        };
      }
    },
  },
  mounted() {
    const self = this;
    self.$nextTick(() => {
      self.tableHeight = self.$getTableHeight("main-container");
    });
    window.onresize = function () {
      self.$nextTick(() => {
        self.tableHeight = self.$getTableHeight("main-container");
      });
    };
    document.addEventListener("keydown", this.keydownFun);
    this.$bus.$on("refreshPage", () => {
      if (this.$route.name === this.$options.name) {
        this.params && (this.params = this.$options.data().params);
        this.handleSearch();
      }
    });
  },
  activated() {
    document.addEventListener("keydown", this.keydownFun);
  },
  deactivated() {
    document.removeEventListener("keydown", this.keydownFun);
  },
  methods: {
    onBatchCancelDelivery() {
      if (this.selections.length === 0) {
        this.$Message.error("请选择需要取消发货的订单");
      } else {
        api
          .batchCancelDelivery({ ids: this.selections.map((item) => item.ID) })
          .then((res) => {
            this.$Message.success(res.Data.str);
            this.handleSearch();
          });
      }
    },
    handleChangeExpressCode(e) {
      if (e) {
        this.bulkShipmentForm.ExpressName = e.label;
      }
    },
    // 获取物流配置信息
    async GetExpressList() {
      try {
        const res = await api.GetExpressList({
          Page: 1,
          PageSize: 100,
        });
        if (res.Data) {
          this.expressList = res.Data.DataList;
        }
      } catch (error) {
        this.$Notice.error({ title: "错误", desc: error });
      }
    },
    handleBulkShipment() {
      if (this.selections.length === 0) {
        this.$Message.error("请选择需要发货的订单");
      } else if (!this.bulkShipmentForm.ExpressCode) {
        this.$Message.error("请选择物流公司");
      } else if (!this.bulkShipmentForm.ShippingDate) {
        this.$Message.error("请选择发货时间");
      } else {
        this.$Spin.show({
          render: (h) => {
            return h("div", [
              h("Icon", {
                class: "demo-spin-icon-load",
                props: {
                  type: "ios-loading",
                  size: 18,
                },
              }),
              h("div", "批量发货中..."),
            ]);
          },
        });
        api
          .BatchDelivery({
            ...this.bulkShipmentForm,
            ids: this.selections.map((item) => item.ID),
          })
          .then((res) => {
            if (res.Data.successList.length) {
              setTimeout(() => {
                this.printSheet(res.Data.successList);
              }, 800);
            } else {
              this.$Message.success(res.Data.str);
            }
          })
          .finally(() => {
            this.$Spin.hide();
            this.isShowBulkShipmentModal = false;
            this.loadOrderList();
          });
        // this.$refs.upload.post(this.uploadFile);
      }
    },
    keydownFun() {
      const self = this;
      var e = event || window.event;
      if (self.$route.name === self.$options.name && e && e.keyCode === 13) {
        // enter 键
        self.handleSearch();
      }
    },
    onSortChange(result) {
      this.params.SortName =
        result.key === "FreightTypeCN" ? "FreightType" : result.key;
      this.params.SortOrder = result.order !== "normal" ? result.order : "desc";
      this.loadOrderList();
    },
    // 日期变化方法
    dateUpdate(value) {
      this.params.OrderDateBegin = value[0];
      this.params.OrderDateEnd = value[1];
    },
    handleCancel(row) {
      const self = this;
      this.$Modal.confirm({
        title: "删除确认",
        loading: true,
        content: "确定要删除该订单吗?",
        okText: "删除",
        async onOk() {
          try {
            await api.DeleteOrder({ ids: row.ID });
            const index = self.resObj.DataList.findIndex(
              (item) => item.ID === row.ID
            );
            if (index !== -1) {
              self.resObj.DataList[index].OrderStatus = -99;
              self.resObj.DataList[index].StatusCN = "已删除";
            }
            self.$Message.success("删除成功");
            self.$Modal.remove();
          } catch (error) {
            this.$Notice.error({ title: "错误", desc: error });
            this.$Modal.remove();
          }
        },
      });
    },
    openDrawer(row, isEdit) {
      this.$refs.DetailDrawer.obj = row;
      this.$refs.DetailDrawer.isShow = true;
      this.$refs.DetailDrawer.isEdit = isEdit;
    },
    handleChangePageSize(pagesize) {
      this.params.Page = 1;
      this.params.PageSize = pagesize;
      this.loadOrderList();
    },
    handleChangePage(page) {
      this.selections = [];
      this.params.Page = page;
      this.loadOrderList();
    },
    handleSearch() {
      this.params.Page = 1;
      this.loadOrderList();
    },
    handleReset() {
      this.$refs.SearchForm.resetFields();
      this.loadOrderList();
    },
    handleSelectCancel(_selection, row) {
      const index = this.selections.findIndex((item) => item.ID === row.ID);
      if (index > -1) {
        this.selections.splice(index, 1);
      }
    },
    handleSelectAllCancel() {
      this.selections = this.selections.filter(
        (obj) => !this.resObj.DataList.some((obj1) => obj1.ID === obj.ID)
      );
    },
    handleSelect(selection) {
      let bigArr = [...this.selections, ...selection];
      let smallArr = [];
      bigArr.some((item) => {
        if (smallArr.findIndex((res) => res.ID === item.ID) === -1) {
          smallArr.push(item);
        }
      });
      this.selections = smallArr;
    },
    batchPrintSheet() {
      if (this.selections.length === 0) {
        this.$Message.error("请选择需要发货的订单");
      } else {
        this.printSheet(this.selections.map((item) => item.OrderCode));
      }
    },
    printSheet(codeArr) {
      api
        .GetBatchPrintInfo({
          orderCodeArr: codeArr,
        })
        .then((res) => {
          document.getElementById("EBusinessID").value = res.Data.EBusinessID;
          document.getElementById("DataSign").value = res.Data.DataSign;
          document.getElementById("RequestData").value = res.Data.RequestData;
          window.printForm.submit();
        })
        .finally(() => {
          this.$Spin.hide();
          this.loadOrderList();
        });
    },
    // 选中行样式
    RowClassName(row) {
      if (
        row.Node &&
        row.Node !== 1050 &&
        row.Node !== 1099 &&
        row.Node !== 1999 &&
        row.Node !== 2050 &&
        row.Node !== 2099 &&
        row.Node !== 2999 &&
        row.Node !== 3040 &&
        row.Node !== 3099 &&
        row.Node !== 3999
      ) {
        return "demo-table-error-row";
      }
      return "";
    },
    async loadOrderList() {
      this.tableLoading = true;
      try {
        const res = await api.GetOrderList(this.params);
        this.resObj = res.Data;
        this.tableLoading = false;
      } catch (err) {
        this.tableLoading = false;
        this.$Notice.error({ title: "错误", desc: err });
      } finally {
        this.selections = [];
        this.bulkShipmentForm = {
          print: false,
          ExpressCode: "",
          ExpressName: "",
          ShippingDate: "",
          isMerge: true,
        };
      }
    },
    async handleOpenUser(MemberID) {
      try {
        const res = await api.GetMemberByCode({
          code: MemberID,
        });
        if (res.Status === 100) {
          this.$refs.userDrawer.obj = res.Data;
          this.$refs.userDrawer.isShow = true;
        } else {
          this.$Message.error(res.Msg);
        }
      } catch (error) {
        this.$Notice.error({
          title: "错误",
          desc: error,
        });
        this.tableLoading = false;
        // TODO: 记录错误日志
      }
    },
  },
  computed: {
    orderStatusEnum() {
      return bizEnum.OrderStatusEnum;
    },
    orderTypeEnum() {
      return bizEnum.OrderTypeEnum;
    },
  },
  components: { DetailDrawer, UserProfileDrawer, Layout },
};
</script>

<style lang="less">
.ivu-table .demo-table-error-row td {
  background-color: #ffd591 !important;
  color: rgb(0, 0, 0);
}
</style>
